<template>
    <svg
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        class="ml-2">
        <path
            d="M30.0768 31.5V38.7823M30.0768 38.7823L19.7228 56M30.0768 38.7823L40.4308 56M30.0768 38.7823L24.6927 47.7356L30.0768 51.9429M30.0768 38.7823L35.4609 47.7356L30.0768 51.9429M30.0768 38.7823V51.9429M30.0768 51.9429V56"
            stroke="#EEEEEE" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32.1168 31.6106H38.2832C39.5539 31.6106 40.5841 30.5804 40.5841 29.3097L40.5841 8.41939C40.5841 7.42902 39.9503 6.54977 39.0108 6.23658L32.8966 4.19852C32.5066 4.06852 32.0889 4.04538 31.6869 4.13152L21.2347 6.37127C20.1738 6.5986 19.4159 7.53613 19.4159 8.62108V29.3097C19.4159 30.5804 20.4461 31.6106 21.7168 31.6106L32.1168 31.6106Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M32.3008 4V31.6106"
            stroke="#EEEEEE" />
        <path
            d="M35.1715 16.3992L35.2751 16.4187L38.0368 17.1082C38.4286 17.2062 38.7037 17.5587 38.7038 17.9626V24.2478C38.7038 24.7341 38.3092 25.1287 37.8229 25.1287H35.0622C34.5759 25.1287 34.1813 24.7341 34.1813 24.2478V17.2722C34.1815 16.7353 34.6546 16.3329 35.1715 16.3992Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M34.1417 21.4867L38.7434 21.9469"
            stroke="#EEEEEE" />
        <path
            d="M26.0889 16.0045C27.0566 16.0046 28.0134 16.6468 28.7539 17.855C29.4893 19.0551 29.96 20.7447 29.96 22.6373C29.9599 24.5298 29.4893 26.2195 28.7539 27.4195C28.0134 28.6278 27.0566 29.2699 26.0889 29.2701C25.1211 29.2701 24.1645 28.6279 23.4238 27.4195C22.6883 26.2195 22.2168 24.53 22.2168 22.6373C22.2168 20.7445 22.6883 19.0551 23.4238 17.855C24.1645 16.6466 25.121 16.0045 26.0889 16.0045Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M25.8585 8.64154C26.1476 8.64159 26.4708 8.81727 26.7443 9.22748C27.0154 9.63418 27.1993 10.225 27.1993 10.9023C27.1993 11.5798 27.0154 12.1713 26.7443 12.5781C26.4708 12.9882 26.1476 13.164 25.8585 13.164C25.5695 13.164 25.2462 12.9881 24.9728 12.5781C24.7016 12.1713 24.5177 11.5798 24.5177 10.9023C24.5178 10.2249 24.7016 9.63418 24.9728 9.22748C25.2463 8.81724 25.5694 8.64154 25.8585 8.64154Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M26.7789 20.6062C27.068 20.6062 27.3912 20.7819 27.6647 21.1921C27.9358 21.5988 28.1197 22.1896 28.1198 22.8669C28.1198 23.5444 27.9359 24.136 27.6647 24.5427C27.3912 24.9528 27.068 25.1286 26.7789 25.1287C26.4899 25.1287 26.1667 24.9528 25.8932 24.5427C25.622 24.136 25.4381 23.5444 25.4381 22.8669C25.4382 22.1896 25.6221 21.5988 25.8932 21.1921C26.1667 20.7819 26.4898 20.6062 26.7789 20.6062Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
    </svg>
</template>

<script setup lang="ts"></script>
